<template>
	<div class="topic-level-cate">
		<div class="row" style="margin-bottom: 20px;">
			<div class="col-xl-6">课题阶段</div>
			<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
		</div>

		<el-card>
			<el-table
				:data="topicLevelTableData"
				style="width: 100%;margin-bottom: 20px;"
				row-key="id"
				border
				default-expand-all
				:tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
				v-show="showType == 1"
			>
				<el-table-column prop="name" label="课题阶段" sortable width="180"></el-table-column>
				<!-- <el-table-column prop="level" label="层级" sortable width="180"></el-table-column> -->
				<el-table-column prop="subjectName" label="课题">
					<template v-slot:default="scope">
						<el-button type="primary" @click="viewTopicList(scope.row.id)">查看课题列表</el-button>
					</template>
				</el-table-column>
				<el-table-column label="管理">
					<template slot-scope="scope">
						<!-- <el-button style="margin-right: 20px;" size="small" type="primary" @click="openDialog('修改', scope.row)">修改课题</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="delConfirm(scope.row.id)"><el-button slot="reference" size="small" type="danger">删除课题</el-button></el-popconfirm> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- <div class="btn-wrap"><el-button size="small" type="primary" @click="openDialog('新增')">添加</el-button></div> -->

			<!-- 课题列表 -->
			<div class="topic_list" v-show="showType == 2">
				<div class="btn-wrap">
					<el-button type="primary" @click="showType = 1">返回</el-button>
					<el-button type="primary" @click="openAddTopicDialog">添加课题</el-button>
				</div>
				<el-table :data="topicList" style="width: 100%" border>
					<el-table-column prop="declareName" label="课题名称"></el-table-column>
					<el-table-column prop="oneEmceeName" label="负责人"></el-table-column>
					<el-table-column prop="projectLevelName" label="课题级别"></el-table-column>
					<el-table-column prop="projectTypeName" label="课题类别"></el-table-column>
					<el-table-column prop="" label="操作">
						<template v-slot:default="scope">
							<el-button type="danger" @click="removeTopic(scope.row.mainId)">移除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="topic_list_pagination" style="margin-top: 10px;">
					<el-pagination
						@size-change="topicListSizeChange"
						@current-change="topicListCurrentChange"
						:current-page="topicListQuery.pageNumber"
						:page-sizes="[20, 50, 100]"
						:page-size="topicListQuery.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="topicListTotal"
					></el-pagination>
				</div>
			</div>
		</el-card>

		<!-- 添加课题到课题阶段中去 -->

		<el-dialog title="提示" :visible.sync="addTopicToTopicPhaseDialogVisible" width="70%" :before-close="handleClose">
			<el-table :data="allTopicList" style="width: 100%" @selection-change="allTopicSelectionChange" border>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="declareName" label="课题名称"></el-table-column>
				<el-table-column prop="oneEmceeName" label="负责人"></el-table-column>
				<el-table-column prop="projectLevelName" label="课题级别"></el-table-column>
				<el-table-column prop="projectTypeName" label="课题类别"></el-table-column>
			</el-table>
			<div>
				<el-pagination
					@size-change="allTopicListSizeChange"
					@current-change="allTopicListCurrentChange"
					:current-page="allTopicListQuery.pageNumber"
					:page-sizes="[10, 50, 100]"
					:page-size="allTopicListQuery.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="allTopicListTotal"
				></el-pagination>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="addTopicToTopicPhaseDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addTopicToTopicPhase">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 添加课题类别对话框 -->
		<el-dialog :title="dialogTitle" :visible.sync="topicCateDialogVisible" width="30%" :close-on-click-modal="false">
			<div class="topic-cate">
				<el-form :model="topicCateForm" :rules="rules" ref="topicCateForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="上级目录" prop="parentId">
						<el-select v-model="topicCateForm.parentId" clearable placeholder="请选择">
							<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="名称" prop="dictName"><el-input v-model="topicCateForm.dictName"></el-input></el-form-item>
					<el-form-item label="描述" prop="remark">
						<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入描述" v-model="topicCateForm.remark" maxlength="200" show-word-limit></el-input>
					</el-form-item>
				</el-form>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="topicCateDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="changeTopicLevelCate">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getPlatformInformationData, addPlatformInformationData, delPlatformInformationData, editPlatformInformationData } from '@/api/after/systemManagement.js';
import { getTopicListByTopicPhaseId, getAllTopicList, addTopicToCurrentPhase, delTopicOnCurrentPhase } from '@/api/after/topicManage.js';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			dialogTitle: '新增',
			topicCateForm: {
				dictTypeId: 1,
				parentId: '',
				dictName: '',
				remark: ''
			},
			rules: {
				parentId: [{ required: false, message: '请选择课题级别', trigger: 'change' }],
				dictName: [{ required: true, message: '请输入课题阶段名称', trigger: 'blur' }]
			},
			topicCateDialogVisible: false,
			topicLevelTableData: [],
			options: [],
			topicListQuery: {
				// 课题列表查询参数
				pageNumber: 1,
				pageSize: 20,
				phaseId: 200 //课题阶段ID
			},
			topicList: [], //课题列表
			topicListTotal: 0, //课题列表总数
			showType: 1, //1为课题阶段列表2为课题列表
			addTopicToTopicPhaseDialogVisible: false, //添加课题到课题阶段对话框
			allTopicList: [], //所有课题列表
			allTopicListQuery: {
				pageNumber: 1,
				pageSize: 10,
				phaseId: 200 //课题阶段ID
			},
			allTopicListTotal: 0, //课题列表总数
			curTopicPhaseId: 0, //当前课题阶段ID
			allTopicSelectionList: [] //所有课题多选
		};
	},
	created() {
		this.getPlatformInformationData();
	},
	methods: {
		// 添加课题到课题阶段
		async addTopicToTopicPhase() {
			// 获取当前选择课题阶段的对象
			let obj = {};
			this.topicLevelTableData.forEach(item => {
				if (item.id == this.curTopicPhaseId) {
					obj = item;
				} else {
					if (item.children && item.children.length > 0) {
						item.children.forEach(item1 => {
							if (item1.id == this.curTopicPhaseId) {
								obj = item1;
							}
						});
					}
				}
			});
			console.log('2123', obj);
			let params = [];
			params = this.allTopicSelectionList.map(item => {
				return {
					projectManagementId: item.id,
					phaseId: obj.id,
					phaseName: obj.name
				};
			});
			const res = await addTopicToCurrentPhase(params);
			if (res.code == 200) {
				this.$message.success('添加成功！');
				this.addTopicToTopicPhaseDialogVisible = false;
				this.getTopicListByTopicPhaseId();
			} else {
				this.$message.error(res.data);
			}
		},
		// 所有课题多选
		allTopicSelectionChange(val) {
			this.allTopicSelectionList = val;
		},
		// 添加课题
		openAddTopicDialog() {
			this.addTopicToTopicPhaseDialogVisible = true;
			this.getAllTopicList();
		},
		// 移除课题
		removeTopic(mainId) {
			this.$confirm('确认移除该课题?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					const res = await delTopicOnCurrentPhase(mainId);
					if (res.code == 200) {
						this.$message.success('移除成功！');
						this.getTopicListByTopicPhaseId();
					} else {
						this.$message.error(res.data);
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			
		},
		// 添加课题到课题阶段下分页切换
		allTopicListSizeChange(val) {
			this.allTopicListQuery.pageSize = val;
		},
		allTopicListCurrentChange(val) {
			this.allTopicListQuery.pageNumber = val;
		},
		// 该阶段下课题列表分页切换
		topicListSizeChange(val) {
			this.topicListQuery.pageSize = val;
		},
		topicListCurrentChange(val) {
			this.topicListQuery.pageNumber = val;
		},
		// 查看课题列表
		viewTopicList(phaseId) {
			this.showType = 2; //显示课题列表
			this.curTopicPhaseId = phaseId;
			this.allTopicListQuery.phaseId = phaseId;
			this.topicListQuery.phaseId = phaseId;
			this.getTopicListByTopicPhaseId();
		},
		// 获取所有课题列表
		async getAllTopicList() {
			const res = await getAllTopicList(this.allTopicListQuery);
			if (res.code == 200) {
				this.allTopicList = res.data.records;
				this.allTopicListTotal = res.data.total;
			} else {
				this.$message.error(res.data);
			}
		},
		// 根据课题阶段ID获取课题列表
		async getTopicListByTopicPhaseId() {
			const res = await getTopicListByTopicPhaseId(this.topicListQuery);
			if (res.code == 200) {
				this.topicList = res.data.records;
				this.topicListTotal = res.data.total;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取课题阶段列表
		async getPlatformInformationData() {
			const res = await getPlatformInformationData(2);
			console.log('课题阶段', res);
			if (res.code == 200) {
				this.options = res.data;
				this.topicLevelTableData = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 添加课题阶段
		async addPlatformInformationData() {
			const res = await addPlatformInformationData(this.topicCateForm);
			if (res.code == 200) {
				this.topicCateDialogVisible = false;
				this.$refs.topicCateForm.resetFields();
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.msg);
			}
		},
		// 删除课题阶段
		async delPlatformInformationData(id) {
			const res = await delPlatformInformationData(id);
			if (res.code == 200) {
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.msg);
			}
		},
		// 修改课题阶段
		async editPlatformInformationData() {
			let params = {
				...this.topicCateForm,
				dictTypeId: 1
			};
			const res = await editPlatformInformationData(params);
			if (res.code == 200) {
				this.topicCateDialogVisible = false;
				this.$refs.topicCateForm.resetFields();
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.msg);
			}
		},
		// 添加或者修改课题阶段
		changeTopicLevelCate() {
			this.$refs.topicCateForm.validate(valid => {
				if (valid) {
					// 如果没有选择上级目录,则创建一级目录
					if (this.topicCateForm.parentId === '') {
						this.topicCateForm.parentId = 0;
					}
					// 防止同级别中名称相同开始
					let isRepeat = true;
					if (this.topicCateForm.parentId === 0) {
						//创建一级类别名称时
						console.log('一级类别', this.topicCateForm);
						if (this.topicLevelTableData.length) {
							isRepeat = this.topicLevelTableData.some(item => {
								return item.name === this.topicCateForm.dictName;
							});
						} else {
							//如果一级列表没有东西
							isRepeat = false;
						}
					} else {
						//创建二级类别名称时
						console.log('二级类别', this.topicCateForm);
						let parentObj = this.topicLevelTableData.find(item => {
							return item.id == this.topicCateForm.parentId;
						});
						if (parentObj.children && parentObj.children.length > 0) {
							isRepeat = parentObj.children.some(item => {
								return item.name === this.topicCateForm.dictName;
							});
						} else {
							isRepeat = false;
						}
					}
					if (isRepeat) {
						return this.$message.error('同级别名称不能相同！');
					}
					// 防止同级别中名称相同结束
					if (this.dialogTitle === '新增') {
						if (this.topicCateForm.parentId === '') {
							this.topicCateForm.parentId = 0;
						}
						this.addPlatformInformationData();
					} else {
						this.editPlatformInformationData();
					}
				} else {
					this.$message.error('没有通过表单验证');
				}
			});
		},
		// 递归获取当前添加课题的父级课题对象
		// notRepeat(arr,val){
		// 	for(let i=0; i<arr.length; i++){
		// 		if (arr[i].id == val) {
		// 			return arr[i]
		// 		}else{
		// 			if (arr[i].children && arr[i].children.length > 0) {
		// 				this.notRepeat(arr[i].children, val)
		// 			}
		// 		}
		// 	}
		// },
		// 确认删除
		delConfirm(id) {
			this.delPlatformInformationData(id);
		},
		// 添加课题类别
		openDialog(actionType, data) {
			this.dialogTitle = actionType;
			if (data) {
				data.dictName = data.name;
				this.topicCateForm = JSON.parse(JSON.stringify(data));
				console.log(this.topicCateForm);
			}
			this.topicCateDialogVisible = true;
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		}
	}
};
</script>

<style scoped lang="scss">
.btn-wrap {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}
</style>
